import React, { Component } from 'react'
import { Link } from 'react-router';
import {ChiTietDoiTuongThanhTraDialog} from 'modules/dialog';
import TextTruncate from 'react-text-truncate';

export default class RowItemDanhMucCuocThanhTra extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chiTietDT: false
    }
  }

  onOpenDialog() {
    this.setState({
      chiTietDT: true
    });
  }

  toggleDialog() {
    this.setState({
      chiTietDT: false
    });
  }

  render() {
    let { noiDungThanhTra, listDoiTuongThanhTra, thoiHanThanhTra, kyThanhTra, thoiGianTienHanh } = this.props.item;
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>
          <div className="mgbt10">
            <Link className='txt-underline txt-regular' onClick={this.onOpenDialog.bind(this)}>
              {this.props.item.ten}
            </Link>
            <ChiTietDoiTuongThanhTraDialog name="chiTietDT" data={this.props.item} open={this.state.chiTietDT} onClose={this.toggleDialog.bind(this)} />
          </div>
          <div>
            {`${listDoiTuongThanhTra.length} đối tượng`}
          </div>
        </td>
        <td>
          <Link className='txt-underline txt-regular' to={'/thanh-tra/cuoc-thanh-tra-trung/chi-tiet/' + this.props.item.id}>
            <TextTruncate
              line={3}
              truncateText="…"
              text={noiDungThanhTra}/>
          </Link>
        </td>
        <td>{thoiHanThanhTra !== 0 ? thoiHanThanhTra : '' }</td>
        <td>{kyThanhTra}</td>
        <td>{thoiGianTienHanh}</td>
      </tr>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/datatable/RowItemDanhMucCuocThanhTra.jsx